/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Form, InputGroup, Table, Modal, Button } from "react-bootstrap";
import React, { useEffect, Fragment } from "react";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import { toTimestamp } from "../utilities/functions";
import { Link, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners"; // Import the loader component
import { Bounce, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExcelJS from "exceljs";
import axios from "axios";
import QRCode from "qrcode";
import { useAuth } from "../context/AuthContext";
import { logHistory } from "../utilities/functions";
import "../assets/css/users.css";
import { usePagePreferences } from "../hooks/usePagePreferences";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

let currentPage = 1;
interface DeletedUser {
  id_user: number;
  name: string;
  // Add other properties if there are more
}
interface User {
  id_user: number;
  id_role: number;
  nom_user: string;
  prenom_user: string;
  username_user: string;
  email_user: string;
  phone_user: string;
  wilaya: string;
  company: string;
  date_creation_user: string; // Assurez-vous que le type de date_creation_user est correct, il est actuellement déclaré comme string
}
export function Users() {
  const { translate } = useTranslate();
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences("users", {
    limit: 10,
    currentPage: 1,
    sortType: "id_user",
    sortDirection: "asc",
    searchTerm: "",
    searchOption: "username_user",
  });
  const [list_user, setListUser] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [limit, setLimit] = useState(Number(listPreferences.limit) || 10);
  const [activePage, setActivePage] = useState(Number(listPreferences.currentPage) || 1);
  const user_id = localStorage.getItem("userid");
  const [loading, setLoading] = useState(true); // Add loading state
  const [showModal, setShowModal] = useState(false);
  const [selecteduser_id, setSelecteduser_id] = useState<string | null>(null);
  const [showDeletedUsersModal, setShowDeletedUsersModal] = useState(false);
  const [deletedUsers, setDeletedUsers] = useState<DeletedUser[]>([]);
  const [deletedUsersCount, setDeletedUsersCount] = useState<number>(0);
  const [sortType, setSortType] = useState(String(listPreferences.sortType || "id_user"));
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">(
    listPreferences.sortDirection === "desc" ? "desc" : "asc"
  );
  const [list, setList] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState(String(listPreferences.searchTerm || ""));
  const [searchOption, setSearchOption] = useState(String(listPreferences.searchOption || "username_user"));
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate(); // Utilisez useNavigate pour la navigation
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const [selectedQrUser, setSelectedQrUser] = useState<User | null>(null);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");

  const { login } = useAuth();

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    const nextLimit = parseInt(newValue, 10);
    setLimit(nextLimit);
    currentPage = 1;
    setActivePage(1);
    setListPreferences({ limit: nextLimit, currentPage: 1 });
    const commentsFormServer = await fetchUser(currentPage, nextLimit);

    setListUser(commentsFormServer);
  };

  const fetchUserData = async (
    currentPage: number,
    limit: number,
    sortType: string,
    sortDirection: string,
    searchTerm?: string,
    searchOption?: string
  ) => {
    try {
      setLoading(true); // Set loading to true on data fetch start

      const totalRes = await fetch(
        `${backendUrl}/api/user/totalpage/${user_id}?searchOption=${searchOption}&searchTerm=${searchTerm}`,
        { mode: "cors" }
      );
      const totalData = await totalRes.json();
      const total = totalData[0].total;
      setTotal(total);

      const calculatedPageCount = Math.ceil(total / limit);
      setPageCount(calculatedPageCount);

      const res = await fetch(
        `${backendUrl}/api/users/iduser/${user_id}?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&searchTerm=${searchTerm}&searchOption=${searchOption}`,
        { mode: "cors" }
      );

      if (!res.ok) {

        throw new Error(
          `Erreur lors de la récupération des utilisateurs. Statut : ${res.status}`
        );
      }

      const data = await res.json();
      setListUser(data);
      setList(data);
    } catch (error) {
      console.error(error);
      // Gérer l'erreur, par exemple, afficher un message à l'utilisateur
    } finally {
      setLoading(false); // Set loading to false on data fetch completion
    }
  };

  useEffect(() => {
    if (!listPreferencesLoaded) return;
    const nextLimit = Number(listPreferences.limit) || 10;
    const nextPage = Number(listPreferences.currentPage) || 1;
    const nextSortType = String(listPreferences.sortType || "id_user");
    const nextSortDirection = listPreferences.sortDirection === "desc" ? "desc" : "asc";
    const nextSearchTerm = String(listPreferences.searchTerm || "");
    const nextSearchOption = String(listPreferences.searchOption || "username_user");

    currentPage = nextPage;
    setActivePage(nextPage);
    setLimit(nextLimit);
    setSortType(nextSortType);
    setSortDirection(nextSortDirection);
    setSearchTerm(nextSearchTerm);
    setSearchOption(nextSearchOption);
    fetchUserData(
      nextPage,
      nextLimit,
      nextSortType,
      nextSortDirection,
      nextSearchTerm,
      nextSearchOption
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, listPreferencesLoaded, listPreferences]);

  useEffect(() => {
    if (!listPreferencesLoaded) return;
    fetchUserData(
      currentPage,
      limit,
      sortType,
      sortDirection,
      searchTerm,
      searchOption
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, sortType, sortDirection, searchOption, searchTerm]);

  const fetchUser = async (currentPage: number, limit: any) => {
    const res = await fetch(
      `${backendUrl}/api/users/iduser/${user_id}?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&searchOption=${searchOption}&searchTerm=${searchTerm}`,
      { mode: "cors" }
    );
    const data = await res.json();
    return data;
  };

  const handlePageClick = async (data: { selected: number }) => {
    currentPage = data.selected + 1;
    setActivePage(currentPage);
    setListPreference("currentPage", currentPage);

    const commentsFormServer = await fetchUser(currentPage, limit);

    setListUser(commentsFormServer);

    fetchUserData(
      currentPage,
      limit,
      sortType,
      sortDirection,
      searchTerm,
      searchOption
    );
  };

  const handleDeleteClick = async (user_id: string) => {
    // Affichez le modal de confirmation avant la suppression
    setSelecteduser_id(user_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    // Fermez le modal
    setShowModal(false);
  };
  const refreshUserData = async () => {
    fetchUserData(
      currentPage,
      limit,
      sortType,
      sortDirection,
      searchTerm,
      searchOption
    );
  };

  const handleConfirmDelete = async () => {
    try {
      // Logique de suppression ici
      const loggedInuser_id = localStorage.getItem("userid");

      const response = await fetch(
        `${backendUrl}/api/softDeleteUser/${selecteduser_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ loggedInuser_id: loggedInuser_id }),
        }
      );
      toast.success(translate("User Deleted successfully !"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la suppression logique. Statut : ${response.status}`
        );
      }

      const result = await response.json();

      // Fermez le modal après la suppression
      setShowModal(false);
      refreshUserData();
      fetchDeletedUsersCount();
    } catch (error) {
      console.error(error);
      // Gérer l'erreur, par exemple, afficher un message à l'utilisateur
    }

    await logHistory(user_id, "Delete", "Users", "supprimer", `Delete user: ${selecteduser_id}`);
  };

  //get deleted users by ID
  const fetchDeletedUsers = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users. Status: ${response.status}`
        );
      }

      const data = await response.json();
      setDeletedUsers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowDeletedUsersModal = () => {
    fetchDeletedUsers(); // Fetch deleted users when modal is opened
    setShowDeletedUsersModal(true);
  };

  const handleCloseDeletedUsersModal = () => {
    setShowDeletedUsersModal(false);
  };

  const fetchDeletedUsersCount = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users-count/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users count. Status: ${response.status}`
        );
      }

      const data = await response.json();
      setDeletedUsersCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDeletedUsersCount(); // Fetch deleted users count on component mount
  }, [user_id]);

  // restor deleted users from the listes
  const handleRestore = async (id_user: number) => {
    try {
      const response = await fetch(`${backendUrl}/api/restoreUser/${id_user}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error restoring the user. Status: ${response.status}`);
      }

      const result = await response.json();

      // Optionally, you can refresh the list of deleted users after restoration
      fetchDeletedUsers();
      fetchDeletedUsersCount();
      refreshUserData();
    } catch (error) {
      console.error(error);
      // Handle the error, e.g., display a message to the user
    }
    toast.success(translate("User Restored successfully !"), {
      position: "bottom-right",
      autoClose: 2400,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  //sort function for user data by id-user
  const handleSort = async (type: "id_user") => {
    let sortOrder: "asc" | "desc" = "asc";

    if (type === sortType) {
      sortOrder = sortDirection === "asc" ? "desc" : "asc";
    }

    setSortType(type);
    setSortDirection(sortOrder);
    setListPreferences({ sortType: type, sortDirection: sortOrder });
  };

  // Fonction pour gérer la sélection des utilisateurs
  const handleSelection = (user_id: number) => {
    // Vérifiez si l'utilisateur est déjà sélectionné
    const isSelected = selectedUsers.includes(user_id);

    if (isSelected) {
      // Si l'utilisateur est déjà sélectionné, retirez-le de la liste
      setSelectedUsers(selectedUsers.filter((id) => id !== user_id));
    } else {
      // Sinon, ajoutez-le à la liste des utilisateurs sélectionnés
      setSelectedUsers([...selectedUsers, user_id]);
    }
  };

  const handleSelectAllCheckboxChange = () => {
    if (selectAll) {
      // Si la case est cochée, désélectionnez tous les utilisateurs
      setSelectedUsers([]);
    } else {
      // Sinon, sélectionnez tous les utilisateurs
      const alluser_ids = list_user.map((item) => item.id_user);
      setSelectedUsers(alluser_ids);
    }
    // Inversez l'état de selectAll
    setSelectAll(!selectAll);
  };

  //excel js fnction
  // Modifiez la fonction de génération d'Excel pour exporter uniquement les utilisateurs sélectionnés
  const generateExcel = async () => {
    // Déselectionner tous les utilisateurs
    setSelectedUsers([]);
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Users");

      // Ajoutez les en-têtes à la feuille Excel avec les styles
      const headers = [
        "ID",
        "Nom",
        "Nom d'utilisateur",
        "Email",
        "Téléphone",
        "Région",
        "Date d'inscription",
      ];
      worksheet.addRow(headers);

      // Ajoutez les données des utilisateurs sélectionnés
      list.forEach((user) => {
        if (selectedUsers.includes(user.id_user)) {
          worksheet.addRow([
            user.id_user,
            `${user.nom_user} ${user.prenom_user}`,
            user.username_user,
            user.email_user,
            user.phone_user,
            user.wilaya,
            toTimestamp(user.date_creation_user).split(" ")[0],
          ]);
        }
      });

      // Ajustez automatiquement la largeur des colonnes pour adapter le contenu
      worksheet.columns.forEach((column) => {
        column.width = Math.max(column.width ?? 0, 25);
      });

      // Générer le fichier Excel
      const buffer = await workbook.xlsx.writeBuffer();
      const currentDate = new Date();
      const dateString = currentDate.toISOString().split("T")[0];
      const timeString = currentDate
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "-");
      const fileName = `Liste_users_${dateString}_${timeString}.xlsx`;

      // Télécharger le fichier Excel
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erreur lors de la génération du fichier Excel :", error);
    }
  };


  const handleUserSelection = async (id_role: number, id_user: number, username: string) => {
    try {
      // Appel backend pour basculer vers un autre utilisateur
      await axios.post(
        `${backendUrl}/api/switch-user`,
        { id_user },
        { withCredentials: true } // important pour le cookie JWT
      );

      // Optionnel : stocke les infos localement
      localStorage.setItem("user_id", id_user.toString());
      localStorage.setItem("username", username);

      // Recharge le contexte utilisateur (/api/me via AuthContext)
      await login();
    } catch (error) {
      console.error("Erreur lors du changement d'utilisateur :", error);
      alert("Impossible de changer d'utilisateur.");
    }
  };



  let placeholderText = translate("Search by ");

  switch (searchOption) {
    case "username_user":
      placeholderText += translate("User name");
      break;
    case "phone_user":
      placeholderText += translate("Phone");
      break;
    case "wilaya":
      placeholderText += translate("region");
      break;
    default:
      placeholderText += "...";
  }

  // Function to handle the change in the input field for search
  const handleSearchTermChange = async (event: any) => {
    const term = event.target.value;
    setSearchTerm(term);
    currentPage = 1;
    setActivePage(1);
    setListPreferences({ searchTerm: term, currentPage: 1 });
  };
  //function for search option change
  const handleSearchOptionChange = (option: string) => {
    setSearchOption(option);
    currentPage = 1;
    setActivePage(1);
    setListPreferences({ searchOption: option, currentPage: 1 });
    setDropdownOpen(false); // Ferme la liste déroulante après avoir sélectionné une option
  };

  const clearSearchTerm = () => {
    setSearchTerm("");
    currentPage = 1;
    setActivePage(1);
    setListPreferences({ searchTerm: "", currentPage: 1 });
  };

  const handleShowQrCode = async (user: User) => {
    setSelectedQrUser(user);
    setShowQrModal(true);
    setQrCodeDataUrl("");

    try {
      const response = await axios.post(
        `${backendUrl}/api/mobile-login-qr/${user.id_user}`,
        {},
        { withCredentials: true }
      );

      const qrPayload = {
        ...response.data,
        backend_url: backendUrl,
      };

      const dataUrl = await QRCode.toDataURL(JSON.stringify(qrPayload), {
        errorCorrectionLevel: "M",
        margin: 2,
        width: 260,
        color: {
          dark: "#020617",
          light: "#ffffff",
        },
      });
      setQrCodeDataUrl(dataUrl);
    } catch (error) {
      console.error("Erreur lors de la génération du QR code :", error);
      toast.error("Impossible de générer le QR code sécurisé.");
      handleCloseQrModal();
    }
  };

  const handleCloseQrModal = () => {
    setShowQrModal(false);
    setSelectedQrUser(null);
    setQrCodeDataUrl("");
  };

  const handleDownloadQrCode = () => {
    if (!qrCodeDataUrl || !selectedQrUser) return;

    const link = document.createElement("a");
    link.href = qrCodeDataUrl;
    link.download = `qr-mobile-${selectedQrUser.username_user || selectedQrUser.id_user}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="users-page">
        <div className="row users-header">
          <div className="col-lg-4 col-md-12">
            <h4 className="users-title">
              <i
                className="las la-user"
                data-rel="bootstrap-tooltip"
                title="Users"
              ></i>
              {translate("Users")} ( {total} )
            </h4>
          </div>
          <div className="col-lg-8 col-md-12">
            <div className="users-actions">
              <div
                id="DataTables_Table_0_filter"
                className="dataTables_filter users-actions-list"
              >
                <Link to="/User" className="btn btn-primary users-toolbar-btn">
                  <i className="las la-plus mr-2"></i>
                  {translate("New Users")}
                </Link>
                <Button
                  className="btn btn-secondary users-toolbar-btn"
                  onClick={handleShowDeletedUsersModal}
                >
                  <i
                    className="las la-trash-alt"
                    data-rel="bootstrap-tooltip"
                    title="Increased"
                  ></i>{" "}
                  {translate("Deleted Users")} ({deletedUsersCount})
                </Button>
                <Button
                  className="btn btn-info users-toolbar-btn"
                  onClick={generateExcel}
                >
                  <i className="las la-file-excel mr-2"></i>
                  {translate("Download Excel")}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row users-controls">
          <div className="col-lg-6 col-md-12">
            <div className="input-group flex-nowrap users-search">
              <div className="input-group-prepend users-search-filter">
                <button
                  className="btn btn-default dropdown-toggle users-search-filter-btn"
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  aria-haspopup="true"
                  aria-expanded={dropdownOpen ? "true" : "false"}
                >
                  <span
                    className="las la-filter"
                    data-toggle="tooltip"
                    title="Rechercher"
                  ></span>
                </button>

                {dropdownOpen && (
                  <ul
                    className="dropdown-menu show-dropdown users-search-menu"
                    role="menu"
                    id="search_by"
                  >
                    <li className={searchOption === "username_user" ? "active" : ""}>
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSearchOptionChange("username_user")}
                      >
                        {translate("username")}
                      </a>
                    </li>

                    <li className={searchOption === "phone_user" ? "active" : ""}>
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSearchOptionChange("phone_user")}
                      >
                        {translate("Phone")}
                      </a>
                    </li>

                    <li className={searchOption === "wilaya" ? "active" : ""}>
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSearchOptionChange("wilaya")}
                      >
                        {translate("region")}
                      </a>
                    </li>
                  </ul>
                )}
              </div>

              <Form.Control
                type="text"
                placeholder={placeholderText}
                className="form-control custom-search-input users-search-input"
                onChange={handleSearchTermChange}
                value={searchTerm}
              />

              {searchTerm && (
                <div className="input-group-append">
                  <button
                    className="btn btn-primary h-100 d-flex align-items-center justify-content-center px-3"
                    onClick={clearSearchTerm}
                    type="button"
                  >
                    <i className="las la-times-circle"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="dataTables_length users-length" id="DataTables_Table_0_length">
              <label>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
                  style={{ width: "66px" }}
                  value={limit}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
                {translate("entries")}
              </label>
            </div>
          </div>


        </div>
      </div >

      <div>
        <div className="users-table-wrap">
          <Table responsive className="users-table">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      id="selectAllCheckbox"
                      onChange={handleSelectAllCheckboxChange} // Ajoutez ceci
                      checked={selectAll} // Pour cocher ou décocher le checkbox en fonction de selectAll
                    />
                    <label htmlFor="selectAllCheckbox" className="mb-0"></label>
                  </div>
                </th>
                <th style={{ width: "199px", cursor: "pointer" }}>
                  <span onClick={() => handleSort("id_user")}>
                    {translate("Id")}
                    {sortType === "id_user" && sortDirection === "asc" && " ▲"}
                    {sortType === "id_user" && sortDirection === "desc" && " ▼"}
                  </span>
                </th>
                <th>{translate("name")}</th>
                <th>{translate("User name")}</th>
                <th>{translate("Company")}</th>
                <th>{translate("Email")}</th>
                <th>{translate("Phone")}</th>
                <th>{translate("region")}</th>
                <th>{translate("Registration date")}</th>
                <th>{translate("Actions")}</th>
              </tr>
            </thead>
            {loading ? (
              <tr>
                <td colSpan={12}>
                  <div className="text-center">
                    <PropagateLoader
                      color={"#123abc"}
                      loading={loading}
                      size={20}
                    />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {Array.isArray(list_user) &&
                  list_user.length !== 0 &&
                  list_user.map((item) => {
                    return (
                      <tbody key={item["id_user"]} className="ligth-body">
                        <tr className={String(item["id_user"])}>
                          <td>
                            <div className="checkbox d-inline-block">
                              <input
                                type="checkbox"
                                className="checkbox-input"
                                id={`checkbox-${item["id_user"]}`}
                                onChange={() =>
                                  handleSelection(item["id_user"])
                                }
                                checked={selectedUsers.includes(
                                  item["id_user"]
                                )}
                              />
                              <label
                                htmlFor={`checkbox-${item["id_user"]}`}
                                className="mb-0"
                              ></label>
                            </div>
                          </td>

                          <td> {item["id_user"]}</td>
                          <td>
                            <div className="users-name-cell">
                              <span className="users-avatar">
                                {(item["nom_user"] || item["username_user"] || "?")
                                  .charAt(0)
                                  .toUpperCase()}
                              </span>
                              <span>
                                {item["nom_user"]} {item["prenom_user"]}
                              </span>
                            </div>
                          </td>
                          <td>{item["username_user"]}</td>
                          <td>{item["company"]}</td>

                          <td id="5">{item["email_user"]}</td>
                          <td>{item["phone_user"]}</td>

                          <td>{item["wilaya"]}</td>
                          <td>
                            {" "}
                            {new Date(
                              item["date_creation_user"]
                            ).toLocaleDateString()}
                          </td>
                          <td>
                            <div className="d-flex align-items-center list-action users-row-actions">
                              <button
                                type="button"
                                className="users-icon-action users-action-qr mr-2"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="QR connexion mobile"
                                onClick={() => handleShowQrCode(item)}
                              >
                                <i className="ri-qr-code-line"></i>
                              </button>
                              {user_id === "1" && ( // Assuming "1" is the superadmin ID
                                <Fragment>
                                  <a
                                    className="badge bg-blue mr-2 users-icon-action"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="GO"
                                    data-original-title="GO"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleUserSelection(
                                        item["id_role"],
                                        item["id_user"],
                                        item["username_user"]
                                      )
                                    }
                                  >
                                    <i className="las la-caret-square-right"></i>
                                  </a>
                                  <Link
                                    to={`/notification-center/${item["id_user"]}`}
                                    className="badge badge-danger mr-2 users-icon-action"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Send notification in APP"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="las la-bell"></i>
                                  </Link>
                                </Fragment>

                              )}
                              <Link
                                to={`/User/${item["id_user"]}`}
                                className="badge badge-success mr-2 users-icon-action"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Modifier"
                                style={{ cursor: "pointer" }}
                              >
                                <i className="ri-pencil-line mr-0"></i>
                              </Link>
                              <a
                                className="badge bg-warning mr-2 users-icon-action"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Delete"
                                data-original-title="Delete"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleDeleteClick(String(item["id_user"]))
                                }
                              >
                                <i className="ri-delete-bin-line mr-0"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
              </>
            )}
          </Table>
        </div>
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {list_user.length} {translate("out of")}{" "}{total}
            </span>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={pageCount}
              forcePage={Math.max(activePage - 1, 0)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>{translate("Confirmation of deletion.")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {translate("Do you really want to delete this user?")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {translate("Cancel")}
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            {translate("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeletedUsersModal}
        onHide={handleCloseDeletedUsersModal}
        dialogClassName="modal-lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {translate("Deleted Users")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display the list of deleted users in a table */}
          <table className="table">
            <thead>
              <tr>
                <th>{translate("ID")}</th>
                <th>{translate("Username")}</th>
                <th className="text-right">{translate("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {deletedUsers.map((user) => (
                <tr key={user.id_user}>
                  <td>{user.id_user}</td>
                  <td>{user.name}</td>
                  <td className="text-right">
                    {/* Buttons for restore and permanent deletion */}
                    <Button
                      variant="success"
                      className="mr-2"
                      onClick={() => handleRestore(user.id_user)}
                    >
                      <i className="las la-trash-restore"> Restore</i>
                    </Button>
                    {/* {user_id === "1" && ( // Assuming "1" is the superadmin ID
                      <Button variant="danger">
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    )} */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeletedUsersModal}>
            {translate("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showQrModal}
        onHide={handleCloseQrModal}
        centered
        dialogClassName="users-qr-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>QR connexion mobile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="users-qr-content">
            <div className="users-qr-user">
              <span className="users-avatar users-avatar-lg">
                {(selectedQrUser?.nom_user || selectedQrUser?.username_user || "?")
                  .charAt(0)
                  .toUpperCase()}
              </span>
              <div>
                <strong>
                  {selectedQrUser?.nom_user} {selectedQrUser?.prenom_user}
                </strong>
                <span>{selectedQrUser?.username_user}</span>
              </div>
            </div>

            <div className="users-qr-box">
              {qrCodeDataUrl ? (
                <img src={qrCodeDataUrl} alt="QR connexion mobile" />
              ) : (
                <PropagateLoader color={"#0d6efd"} loading size={10} />
              )}
            </div>

            <p className="users-qr-note">
              Scanner ce QR code avec l'application mobile pour identifier ce
              client. Le code expire après 2 minutes et ne peut être utilisé
              qu'une seule fois.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseQrModal}>
            {translate("Close")}
          </Button>
          <Button
            variant="primary"
            onClick={handleDownloadQrCode}
            disabled={!qrCodeDataUrl}
          >
            <i className="las la-download mr-2"></i>
            Télécharger
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
